import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { AccountService } from '../../shared/services/account.service';
import { AppService } from "../../shared/services/app.service";
import { Router, ActivatedRoute } from '@angular/router';
import { LanguageService } from '../../shared/services/language.service';
import { BasketService } from '../../shared/services/basket.service';
import { CardConfig } from 'src/app/shared/components/tarifs-card/tarifs-card.component';
import {TranslateService} from "@ngx-translate/core";
import { LocalstorageService } from '../../shared/services/localstorage.service';
import { environment } from '../../../environments/environment';
import { DOCUMENT } from '@angular/common';

declare var $: any; import {isBrowser} from '../../shared/thirdparty/isBrowser'
declare var Swal:any;

@Component({
    selector: 'app-security-day',
    templateUrl: './security-day.component.html',
    styleUrls: ['./security-day.component.css']
})
export class SecurityDayComponent implements OnInit {

    public prices:any = {}
    public loading = true
    public logged: boolean

    priceCards: CardConfig[] = [
		{
			title: this.translate.instant('Université'),
			price: 2800,
			img: {
				name: 'Tarifs_Abonnement_Campus',
				alt: 'Campus subsription',
			},
            description: 'Vous êtes une <b>école</b>, une université, un campus et vous souhaitez former également à distance en utilisant la dernière technologie metaverse',
            dots:[
                {text: 'Accès online au campus'},
                {text: 'A partir de 100 participants pendant 1 an'},
                {text: 'De 10 à 100 places en simultanées'},
                {text: 'Le passage d’un exercice par jour'},
                {text: 'PC windows & Viewer Mac (campus)'},
            ],
            mainButton: {
                action: ()=>{ this.subscribe('campus') }
            },
            yellowText:{
                text: '',
                route: '/',
                title: ''
            },
            learnMore: {
                text: 'no',
                action: ()=>{}
            },
		},
	];

    constructor(
        public accountService : AccountService,
        public appService : AppService,
        public router : Router,
        public language : LanguageService,
        public basketService : BasketService,
        public translate : TranslateService,
        public route: ActivatedRoute,
        public localStorage : LocalstorageService,
        @Inject(DOCUMENT) public document: Document
    ) {}


    ngOnInit() {
        if(isBrowser() && $('video') && $('video').length){
            for (let i = 0; i<$('video').length; i++) {
                $('video')[i].muted = true;
                $('video')[i].load();
            }
        }
        this.refreshPrices()
        this.checkAccount();
    }

    checkAccount(){
        this.logged = this.accountService.isLogged();
    }

    refreshPrices(){
        this.loading = true
        return this.basketService.getPrices()
        .then((prices)=>{
            this.loading = false
            this.prices = prices
            this.priceCards[0].price = prices.workshops_annual
        })
    }

    subscribe(type){
        if(type == 'campus'){
            this.localStorage.setItem('basket', JSON.stringify({
                items:[
                    {type:'campus', period:'annual', quantity:10},
                    {type:'users_subscription', period:'annual', quantity:100}
                ]
            }))
            this.router.navigate(this.language.navigateAccordingToLang(['/basket']))
        }
    }

    freeAccess(){
        this.router.navigate(this.language.navigateAccordingToLang(['/demo']))
    }

}
